import { createSelector } from "reselect";
import _groupBy from "lodash/groupBy";
import { RootState as RS } from "../../types";
import { getNotificationsSlice } from "../selectors";

export const getSystemNotificationSlice = (s: RS) =>
  getNotificationsSlice(s).system;

export const getSystemNotificationMessages = (s: RS) =>
  getSystemNotificationSlice(s).messages;

export const getSystemNotificationsFetchStatus = (s: RS) =>
  getSystemNotificationSlice(s).fetchStatus;

export const getMappingNotifications = createSelector(
  getSystemNotificationMessages,
  (msgs) => msgs.filter((msg) => msg.type === "mapping")
);

export const getMappingNotificationsByDatasourceId = createSelector(
  getMappingNotifications, // I <3 PRETTIER
  (msgs) => _groupBy(msgs, (msg) => msg.datasourceId)
);
